
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("todomvc/app", function(){ return i("todomvc/app.js");});
d("todomvc/config/environment", function(){ return i("todomvc/config/environment.js");});
d("todomvc/router", function(){ return i("todomvc/router.js");});
d("todomvc/services/repo", function(){ return i("todomvc/services/repo.js");});
d("todomvc/services/ember-primitives/setup", function(){ return i("todomvc/services/ember-primitives/setup.js");});
d("todomvc/services/page-title", function(){ return i("todomvc/services/page-title.js");});
d("todomvc/component-managers/glimmer", function(){ return i("todomvc/component-managers/glimmer.js");});
d("todomvc/services/-ensure-registered", function(){ return i("todomvc/services/-ensure-registered.js");});
d("todomvc/templates/active", function(){ return i("todomvc/templates/active.js");});
d("todomvc/routes/active", function(){ return i("todomvc/routes/active.js");});
d("todomvc/templates/application", function(){ return i("todomvc/templates/application.js");});
d("todomvc/routes/application", function(){ return i("todomvc/routes/application.js");});
d("todomvc/templates/completed", function(){ return i("todomvc/templates/completed.js");});
d("todomvc/routes/completed", function(){ return i("todomvc/routes/completed.js");});
d("todomvc/templates/index", function(){ return i("todomvc/templates/index.js");});
d("todomvc/routes/index", function(){ return i("todomvc/routes/index.js");});





if (!runningTests) {
  i("../app").default.create({});
}

